export const generalConfig = {
    supportEmail: "beacon@staffs.ac.uk",
    termsUrl: "https://www.staffs.ac.uk/data-protection/beacon-privacy-statement.jsp",
}